<ng-container [formGroup]="form">


  <div class="grid-x">
    <div class="cell large-12 medium-12 small-12 bold">
      <div class="section-header" [ngClass]="{ 'active' : true}" (click)="toggleOpen()">
        <span class="margin-right">User Updates</span>
        <button class="icon-button">
          @if (isOpen == false) {
            <svg-icon icon="icon-caret-right"></svg-icon>
          }
          @if (isOpen == true) {
            <svg-icon icon="icon-caret-down"></svg-icon>
          }
        </button>
      </div>
    </div>
  </div>
  <div class="grid-x margin-top align-justify" [ngClass]="{ 'hideSection': isOpen == false }">

    <div class="cell large-3 medium-3 small-3 casing-field bold border-bottom-left padding-all">
      <label>Well Disposition</label>
      <select formControlName="disposition" (ngModelChange)="onChange($event)">

        @for (options of dispositionOptions; track options) {
          <option [value]="options.Code">{{options.Definition}}</option>
        }
      </select>
    </div>

    <div class="cell large-3 medium-3 small-3 casing-field bold border-bottom-left padding-all">
      <label>Map Symbol</label>
      <select formControlName="wellSymbol">

        @for (symbol of wellSymbols; track symbol) {
          <option [value]="symbol.Code">{{symbol.Definition}}</option>
        }
      </select>
    </div>

    <div class="cell large-3 medium-3 small-3 casing-field bold border-bottom-left padding-all">
      <label>Legacy Tracking</label>
      <select formControlName="legacyTracking">

        @for (legacyTracking of _legacyTrackingValues; track legacyTracking) {
          <option [selected]="_well.wellStatus.legacyTracking == legacyTracking.Code || legacyTrackingValue == legacyTracking.Code" [value]="legacyTracking.Code">{{legacyTracking.Definition}}</option>
        }
      </select>
    </div>

    <div class="cell large-3 medium-3 small-3 casing-field bold border-bottom-left padding-all">
      <label>Well Type Description</label>
      <select formControlName="wellTypeDesc">

        @for (wellType of wellTypeDescriptionDomainValues; track wellType) {
          <option [selected]="_well.wellStatus.type.description == wellType.Code" [value]="wellType.Code">{{wellType.Definition}}</option>
        }
      </select>
    </div>

  </div>
